import {
  BackendAxios,
  backendAxiosFactory,
} from './backend';
import Firebase from './Firebase';

export class Connections {
  backend: BackendAxios;

  static firebase = Firebase;

  constructor() {
    this.backend = backendAxiosFactory();
  }
}

export * from './types';
